import { useMediaQuery } from "@mui/material";

export const useIsMobile = () => {
  const isMobile = useMediaQuery("@media (max-width: 600px)", {
    noSsr: true
  });

  return isMobile;
};
